import { Suspense } from "react";
import s from "./OrganizationCard.module.css";
import classNames from "classnames";
import PropTypes from "prop-types";
import Button from "../Button";
import SVGIcon from "../SVGIcon/SVGIcon.tsx";
import formatSwedishPhoneNumber from "../utils/formatSwedishPhoneNumber";
import {useFindOrganizationsMapStore, useMapStore} from "../FindOrganizationsMap/store";
import { useMediaQuery } from "usehooks-ts";
export function OrganizationCard({
    organization,
    showDirectionsLink,
    cardHandler,
    onClick,
    forceHidePagination,
    hide = false,
    grouped = [],
}) {
    
    const { name, address, phone, webpageUrl, fairTransport, geoLocation } =
        organization;

    const websiteUrl = (() => {
        if (!webpageUrl) return "";

        let modifiedUrl = webpageUrl;

        if (!webpageUrl.startsWith("http")) {
            modifiedUrl = "https://" + webpageUrl;
        }
        try {
            const url = new URL(modifiedUrl);
            const path = url.pathname === "/" ? "" : url.pathname;
            return url.host.replace("www.", "") + path;
        } catch (e) {
            return webpageUrl;
        }
    })();

    const checkIfGeoLocationExists = () =>
        !!(geoLocation?.latitude && geoLocation?.longitude);

    const clickHandler = checkIfGeoLocationExists() ? onClick : () => {};
    const formatedPhoneNumber = formatSwedishPhoneNumber(phone);
    const showMap = useFindOrganizationsMapStore((state) => state.showMap);
    const isDesktopSize = useMediaQuery("(min-width: 992px)");
    const hideShowOnMapLink = isDesktopSize || showMap;
    const WebpageUrlClasses = classNames(s.WrapRow, s.mb_08, {
        [s.mb_16]: showDirectionsLink,
    });

    const showPagination = useFindOrganizationsMapStore(
        (state) => state.showCardPagination,
    );

    const lastPage = useFindOrganizationsMapStore((state) => state.lastPage);

    const currentPage = useFindOrganizationsMapStore(
        (state) => state.currentPage,
    );

    const setCurrentPage = useFindOrganizationsMapStore(
        (state) => state.setCurrentPage,
    );
    const setSelectedItem = useFindOrganizationsMapStore(
        (state) => state.setSelectedItem,
    );
    const markerGroups = useFindOrganizationsMapStore(
        (state) => state.markerGroups,
    );

    const handleCurrentPage = (value) => {
        const current = grouped[value - 1];
        setSelectedItem(current);
        setCurrentPage(value);
    };
    const shouldShowPagination = showPagination && !forceHidePagination;

    const rootClasses = classNames(s.root, {
        [s.MapCardWithDirection]: showDirectionsLink,
        [s.m_04]: !showDirectionsLink,
        [s.ShowPagination]: shouldShowPagination,
    });
    const telephoneClasses = classNames(s.WrapRow, {
        [s.mb_08]: !webpageUrl,
        [s.mb_16]: showDirectionsLink && !webpageUrl,
    });
    const getDirectionsLink = new URL(
        `https://www.google.com/maps/dir/?api=1&destination_place_id=${name}&destination=${geoLocation?.latitude},${geoLocation?.longitude}`,
    );
    console.log(currentPage + 1 >= lastPage);

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <div onClick={clickHandler} className={rootClasses}>
                {!hide && (
                    <>
                        {name && (
                            <span className={s.WrapRow}>
                                <h5 onClick={clickHandler} className={s.Title}>
                                    {name}
                                </h5>
                                {!hideShowOnMapLink &&
                                    geoLocation?.latitude &&
                                    geoLocation.longitude && (
                                        <span className={s.ShowOnMap}>
                                            Visa på karta
                                        </span>
                                    )}
                                {isDesktopSize &&
                                    geoLocation?.latitude &&
                                    geoLocation?.longitude && (
                                        <SVGIcon
                                            icon="roundArrow"
                                            className={s.ArrowDesktop}
                                        />
                                    )}
                            </span>
                        )}
                        {address && <span className={s.Adress}>{address}</span>}

                        {phone && (
                            <span className={telephoneClasses}>
                                <span className={s.ActionTitle}>Telefon</span>
                                <span className={s.Telephone}>
                                    <a href={"tel:" + formatedPhoneNumber}>
                                        {formatedPhoneNumber}
                                    </a>
                                </span>
                            </span>
                        )}
                        {webpageUrl && (
                            <span className={WebpageUrlClasses}>
                                <span className={s.ActionTitle}>Hemsida</span>

                                <a
                                    rel="noreferrer noopener"
                                    href={webpageUrl}
                                    className={s.LinkUrl}
                                    target={"_blank"}
                                >
                                    <span className={s.Url}>{websiteUrl}</span>
                                </a>
                            </span>
                        )}
                        <div className={s.FairTransport} onClick={clickHandler}>
                            {fairTransport && !showDirectionsLink && (
                                <>
                                    <img
                                        src="/logos/FairTransport.svg"
                                        className={s.FairTransportImage}
                                        alt="Fair Transport"
                                    />
                                    <span>
                                        Certifierad enligt Fair Transport
                                    </span>
                                </>
                            )}
                        </div>

                        {showDirectionsLink && (
                            <>
                                <a
                                    href={getDirectionsLink.toString()}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={s.DirectionsLink}
                                >
                                    Vägbeskrivning i Google Maps
                                    <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>

                                <Button
                                    icon="burgundyorangeclose"
                                    variant="icon-only"
                                    position="top-right"
                                    onClick={cardHandler}
                                />
                            </>
                        )}
                        {shouldShowPagination && (
                            <div className={s.Pagination}>
                                <Button
                                    onClick={() =>
                                        currentPage - 1 >= 1
                                            ? handleCurrentPage(currentPage - 1)
                                            : handleCurrentPage(lastPage)
                                    }
                                    variant={"icon-only"}
                                    icon={"chevronGradient"}
                                    className={classNames(
                                        s.PaginationButton,
                                        s.Previous,
                                    )}
                                >
                                    <span className={"sr-only"}>
                                        Föregående
                                    </span>
                                </Button>
                                <div className={s.PaginationGutter}>
                                    Visar {currentPage} av {lastPage} företag
                                </div>
                                <Button
                                    onClick={() =>
                                        currentPage < lastPage
                                            ? handleCurrentPage(currentPage + 1)
                                            : handleCurrentPage(1)
                                    }
                                    className={classNames(
                                        s.PaginationButton,
                                        s.Next,
                                    )}
                                    variant={"icon-only"}
                                    icon={"chevronGradient"}
                                >
                                    <span className={"sr-only"}>Nästa</span>
                                </Button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </Suspense>
    );
}

OrganizationCard.propTypes = {
    organization: PropTypes.shape({
        name: PropTypes.string,
        address: PropTypes.string,
        phone: PropTypes.string,
        webpageUrl: PropTypes.string,
        fairTransport: PropTypes.bool,
        geoLocation: PropTypes.shape({
            latitude: PropTypes.number,
            longitude: PropTypes.number,
        }),
    }),
    showDirectionsLink: PropTypes.bool,
};
const OrganizationCardMemo = React.memo(OrganizationCard);
export default OrganizationCard;
export {OrganizationCardMemo}
